import { Component, OnDestroy, OnInit } from '@angular/core';
import {ActivatedRoute, NavigationCancel, NavigationEnd, Router} from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { DrawerComponent } from '../../../kt/components';
import {BehaviorSubject} from "rxjs";
import {TitleService} from "../../../../services/title.service";
@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent implements OnInit, OnDestroy {

  private unsubscribe: Subscription[] = [];

  constructor(private router: Router, private route:ActivatedRoute, public title: TitleService) {
    this.routingChanges();
  }

  ngOnInit(): void {
  }

  routingChanges() {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(event.urlAfterRedirects){
          const findItem = this.title.findItem(event.urlAfterRedirects);
          if(findItem.title){
            this.title.$title.next(findItem.title as string);
            this.title.$subtitle.next(findItem.subtitle as string);
          }
        }
      }
    });

    this.unsubscribe.push(routerSubscription);
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
